import { render, staticRenderFns } from "./InfoDetailCart.vue?vue&type=template&id=6c5f1997&scoped=true"
import script from "./InfoDetailCart.vue?vue&type=script&lang=js"
export * from "./InfoDetailCart.vue?vue&type=script&lang=js"
import style0 from "./InfoDetailCart.vue?vue&type=style&index=0&id=6c5f1997&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5f1997",
  null
  
)

export default component.exports